'use strict';

var _makeComponentIntl = require('common/utils/make-component-intl');

var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);

var _legacyAppConnector = require('./legacy-app-connector');

var _legacyAppConnector2 = _interopRequireDefault(_legacyAppConnector);

var _signatureModal = require('ui/signature-modal');

var _signatureModal2 = _interopRequireDefault(_signatureModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = (0, _makeComponentIntl2['default'])((0, _legacyAppConnector2['default'])(_signatureModal2['default']));


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/signature-modal.jsx
 ** module id = 780
 ** module chunks = 0 1
 **/